"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = Arrow;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  size: _propTypes.number,
  height: _propTypes.string,
  width: _propTypes.string
} : {};
const IconContainer = _stylitas.styled.svg`
  width: ${props => props.size <= 24 ? 24 : props.size}px;
  height: ${props => props.size <= 24 ? 24 : props.size}px;
`;

function Arrow({
  size = 24,
  height,
  width,
  ...props
}) {
  return (0, _core.jsx)(IconContainer, {
    size: size
  }, (0, _core.jsx)("svg", (0, _extends2.default)({
    width: height,
    height: width,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _core.jsx)("path", {
    d: "M25.333 16H6.667M18.666 22.667L25.334 16M18.666 9.333L25.334 16",
    stroke: "#1F2D27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

process.env.NODE_ENV !== "production" ? Arrow.propTypes = propTypes : void 0;
Arrow.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Arrow",
  "props": {
    "size": {
      "defaultValue": {
        "value": "24",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "height": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "width": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};